export class LoginServiceConstants {
  static readonly USER_SET_PASSWORD = 'User needs to set password.';
  static readonly AUTHENTICATION_ERROR = 'UserLoginService: Callback in isAuthenticated() cannot be null';
  static readonly LOGGED_IN_ERROR = 'Can\'t retrieve the CurrentUser';
}
